export const PRODUCTS = {
  'vector-mc-accelerator': {
    title: 'Vector Accelerator C++ Library',
    description: 'Vector Accelerator is designed for cases where user simply wants to process multiple samples of data and utilize SIMD(AVX2 or AVX512) and multi-thread to gain a x200 magnitude increase in speed performance.'
  },
  'parallel-addc-lib': {
    title: 'Parallel AADC C++ Library',
    description: 'AAD-C is a novel approach to implement automatic adjoint differentiation of C++ programs with focus on computations where derivatives are required for multiple instances of input data.'
  },
};